export default {
  // 로그인
  login: {
    lang: '언어',
    systemname: '로그인',
    username: '사용자',
    username_label: '사용자명을 입력하세요',
    pwd: '비밀번호',
    pwd_label: '비밀번호를 입력하세요',
    pwd_info: '올바른 비밀번호 형식을 입력하세요',
    success_msg: '로그인 성공',
    error_name: '비밀번호가 올바르지 않습니다',
    error_res: '로그인 요구사항을 충족하지 않습니다',
    login: '로그인',
  },
  // 사이드바
  aside: {
    systemname: '관리',
    quit: '로그아웃',
    deviceControl: '제어',
    basicSetting: '설정',
    workerSetting: '인원',
    deviceMonitoring: '모니터링',
    recordManagement: '기록',
    securityManagement: '키 관리',
    tips: '알림',
    tips_msg: '로그아웃하시겠습니까?',
  },
  control: {
    remoteControl: '원격',
    restart: '재부팅',
    clickToRestart: '클릭하여 재부팅',
    restartConfirm: '재부팅을 확인하시겠습니까?',
    restartSuccess: '재부팅 성공',
    restartFailed: '재부팅 실패',
    remoteOpen: '원격 개방',
    clickToOpen: '클릭하여 개방',
    openConfirm: '원격 개방을 확인하시겠습니까?',
    remoteOpenSuccess: '개방 성공',
    remoteOpenFailed: '개방 실패',
    reset: '장치 초기화',
    clickToReset: '클릭하여 초기화',
    resetConfirm: '초기화를 확인하시겠습니까?',
    resetSuccess: '초기화 성공',
    resetFailed: '초기화 실패',
    firmwareUpgrade: '펌웨어 업그레이드',
    upgradeConfig: '업그레이드 설정',
    firmwareUrl: '펌웨어 URL',
    md5Checksum: 'md5 값',
    startUpgrade: '업그레이드 시작',
    urlRequired: 'URL은 필수입니다',
    md5Required: 'md5는 필수입니다',
    urlInvalid: '올바른 URL을 입력하세요',
    md5Invalid: '올바른 md5를 입력하세요',
    upgradeConfirm: '업그레이드를 진행할까요?',
    upgradeSuccess: '업그레이드 성공',
    clearFile: "파일 지우기",
    uploading: '업로드 중...',
    uploadAndUpgrade: '업로드 후 업그레이드',
    restartTips: '안전한 재부팅, 데이터 손실 없음',
    restarting: '재부팅 중...',
    remoteTips: '출입 원격 제어',
    opening: '개방 중...',
    resetTips: '공장 초기화, 모든 데이터 삭제',
    reseting: '초기화 중...',
    urlUpgrade: 'URL 업그레이드',
    fileUpgrade: '파일 업그레이드',
    uploadFile: '펌웨어 파일 업로드',
    formatFile: '.zip 또는 .dpk 지원, 최대 20MB',
    fileName: '파일명',
    size: '크기',
  },
  config: {
    second: '초',
    millisecond: '밀리초',
    min: '분',
    notsave: '저장 안 함',
    save: '저장',
    noVoice: '음성 없음',
    no: '아니오',
    yes: '예',
    basicConfiguration: '기본 설정',
    displaySettings: '디스플레이 설정',
    informationDisplay: '정보 표시',
    audioSettings: '오디오 설정',
    languageAndThemes: '언어 및 테마',
    autoAdjustScreenBrightness: '자동 밝기 조절',
    screenBrightness: '화면 밝기',
    autoTurnOffScreen: '자동 화면 끄기',
    autoTurnOffScreenTime: '화면 끄기 시간',
    autoScreenSaver: '자동 화면보호기',
    autoScreenSaverTime: '화면보호기 시간',
    displayDeviceSn: 'SN 표시',
    displayIp: 'IP 표시',
    displayIdentityCard: '클라우드 인증 표시',
    volume: '볼륨',
    language: '언어',
    displayCode: "미니앱 코드 표시",
    themeMode: "테마",
    cn: '중국어',
    en: '영어',
    es: '스페인어',
    fr: '프랑스어',
    de: '독일어',
    ru: '러시아어',
    ar: '아랍어',
    pt: '포르투갈',
    ko: '한국어',
    standardMode: '표준 모드',
    simpleMode: '심플 모드',
    firstLogin: '첫 로그인',
    backlight: '배경 조명',
    brightness: '화이트 라이트',
    nirBrightness: '적외선 라이트',
    never: '안 함',
    min1: '1분',
    min2: '2분',
    min3: '3분',
    min4: '4분',
    min5: '5분',
    networkConfiguration: '네트워크 설정',
    otherConfiguration: '기타 설정',
    ipConfiguration: 'IP 설정',
    devicePassword: '장치 비밀번호',
    protocolPassword: '프로토콜 비밀번호',
    networkType: '네트워크 유형',
    ethernet: '이더넷',
    wifiName: 'Wi‑Fi 이름',
    wifiPassword: 'Wi‑Fi 비밀번호',
    dhcpModeSelection: 'DHCP 모드',
    dhcpMode: '자동',
    customNetworkConfiguration: '수동 설정',
    ipAddress: 'IP 주소',
    gateway: '게이트웨이',
    subnetMask: '서브넷 마스크',
    dnsServer: 'DNS 서버',
    mac: '네트워크 MAC',
    mqttRelatedConfiguration: 'MQTT 설정',
    mqttConnectionInformation: 'MQTT 연결 정보',
    sessionConfiguration: '세션 설정',
    serverAddress: '서버 주소',
    clientID: '클라이언트 ID',
    userName: '사용자명',
    userPassword: '비밀번호',
    topicPrefix: '토픽 접두사',
    onlineChecking: '온라인 확인',
    onlineCheckingTimeout: '타임아웃',
    cleanSession: '클린 세션',
    clientIdSuffix: '클라이언트 ID 접미사',
    willTopic: 'Will 토픽',
    enterpriseWechat:'Enterprise WeChat 모드 적용 안 됨',
    faceRelatedConfiguration: '얼굴 설정',
    functionalInformation: '기능 정보',
    prompt: '프롬프트',
    faceSimilarityThreshold: '유사도 임계값',
    livenessDetectionFunction: '라이브니스 감지',
    livenessDetectionThreshold: '라이브니스 임계값',
    infraredImageDisplay: "적외선 이미지 표시",
    maskRecognition: "마스크 인식",
    strangerVoice: "낯선이 음성",
    voiceMode: "음성 모드",
    voiceModeDate: '맞춤 인사',
    imageSaveType: "이미지 저장 유형",
    saveStrangerImage: "낯선이 이미지 저장",
    fullView: "전경",
    face: "얼굴",
    broadcastPleaseRegisterFirst: '"등록 후 이용" 재생',
    broadcastHelloStranger: '"낯선이" 재생',
    broadcastName: '이름 재생',
    broadcastGreeting: '맞춤 인사 재생',
    greeting: '인사말',
    broadcastWelcome: '"환영합니다" 재생',
    recognitionSwitch: '재검사 스위치',
    systemRelatedConfiguration: '시스템 설정',
    functionSwitch: '기능 스위치',
    cardSwipingSwitch: '카드',
    passwordSwitch: '비밀번호',
    strangerImage: '낯선이 이미지',
    cloudCertificateSwitch: '클라우드 인증',
    physicalCardNumber: '물리 카드 번호',
    cloudCertificateAcquisition: '클라우드 인증 획득',
    heartbeatConfig: '하트비트',
    heartbeatSwitch: '하트비트 스위치',
    heartRateInterval: '인터벌',
    heartbeatTopic: '하트비트 토픽',
    heartbeatContent: '하트비트 내용',
    basicInformation: '기본 정보',
    deviceMac: 'MAC 주소',
    uuid: 'UUID',
    sn: 'SN',
    model: '모델',
    version: "버전",
    appVersion: "펌웨어 버전",
    releaseTime: "업데이트 시간",
    totaldisk: '총 공간',
    freedisk: '잔여 공간',
    passageConfiguration: '출입 설정',
    functionConfiguration: '기능 설정',
    numberOfPassageRecords: '최대 출입 기록 수',
    durationOfRelayOpening: '릴레이 개방 시간',
    alarmSwitch: '경보',
    fireAlarmSwitch: '화재 경보',
    fireAlarmStatus: '화재 상태',
    normal: '정상',
    warning: '경고',
    tamperSwitch: '방범 알람',
    uploadToCloudSwitch: '얼굴 업로드 스위치',
    clockConfiguration: '시계 설정',
    timeSynchronizationSwitch: '시간 동기화',
    timeSynchronizationServerIP: '시간 서버 IP',
    timedSynchronizationTime: '동기화 시간',
    timeZone: '시간대',
    setDeviceTime: '장치 시간 설정',
    restartAfterSetting: '설정 후 장치 재부팅',
    cloudCertificateActivation: '클라우드 인증 활성화',
    activationKey: '활성화 키',
    cloudTips1: '공백 없이 키를 입력하세요',
    cloudTips2: '활성화 후 클라우드 서비스에 연결됩니다',
    confirmActivation: '활성화 확인',
    activationInProgress: '활성화 중...',
    activationFailed: '활성화 실패',
    activationSuccessful: '활성화 성공',
    passwordModification: '비밀번호 변경',
    password: '비밀번호',
    oldPassword: '현재 비밀번호',
    newPassword: '새 비밀번호',
    confirmPassword: '비밀번호 확인',
    passwordRule: '비밀번호 권장 사항',
    passwordLength: '길이 ≥6',
    cannotBeTheSame: '모두 같은 문자 불가',
    cannotOrder: '연속 3개 이상 숫자/소문자 불가',
    cannotWeakPassword: '일반적인 약한 비밀번호 금지',
    submit: '제출',
    saveConfig: '설정 저장',
    msg_please_enter: '내용을 입력하세요',
    msg_inputPassword: '비밀번호를 입력하세요',
    msg_oldPasswordError: '현재 비밀번호가 틀렸습니다',
    msg_password_mismatch: '비밀번호가 일치하지 않습니다',
    msg_password_min_length: '비밀번호는 최소 6자',
    msg_is_weak_password: '약한 비밀번호입니다. 변경하세요',
    msg_pswChangeSuccessAndLogin: '비밀번호 변경 완료, 다시 로그인하세요',
    msg_pswChangeSuccess: '비밀번호 변경 성공',
    msg_pswChangeFail: '비밀번호 변경 실패',
    msg_saveSuccess: '저장 성공',
    msg_saveFail: '저장 실패',
    msg_formFilled: '양식 입력을 확인하세요',
    msg_number_0_23: '0~23만 지원',
    msg_number_0_24: '0~24만 지원',
    msg_noChange: '저장할 구성 변경 사항이 없습니다',
    resourceConfiguration: '리소스 설정',
    backgroundImage: '배경 이미지',
    selectImage: '이미지 선택',
    uploadBackground: '배경 업로드',
    uploading: '업로드 중...',
    backgroundUploadTip: '픽셀 수가 {n}인 PNG 형식의 이미지를 업로드하세요. 이미지는 Base64 형식으로 변환된 후 기기로 업로드됩니다.',
    backgroundResolutionMismatch: '이미지 해상도는 {n} 이어야 합니다',
    backgroundRequired: '배경 이미지를 선택하세요',
    backgroundImageOnlyPNG: 'PNG 이미지만 허용',
    backgroundSizeLimit: '이미지 크기는 5MB 이하',
    backgroundParseFailed: '이미지 읽기 실패, 다시 시도',
    backgroundImageSelected: '이미지가 선택되었습니다',
    backgroundSuccess: '배경 업로드 성공',
    backgroundFailed: '배경 업로드 실패',
    scanSettings: '스캔 설정',
    scanSwitch: '스캔 스위치',
    scanInterval: '스캔 간격',
  },
  person: {
    idCard: '신분증 번호',
    userType: '사용자 유형',
    administrator: '관리자',
    userId: 'ID',
    user: '사용자',
    voucher: '자격 증명',
    permission: '권한',
    addUser: '사용자 추가',
    name: '이름',
    editUser: '사용자 수정',
    placeholderUserId: '사용자 ID를 입력하세요',
    placeholderName: '이름을 입력하세요',
    userNotExist: '사용자가 존재하지 않습니다',
    oneClickClear: '모두 삭제',
    clearTips: '모든 데이터가 삭제됩니다. 계속하시겠습니까?',
    clearSuccess: '삭제 완료',
    clearFailed: '삭제 실패',
  },
  voucher: {
    password: '비밀번호',
    card: '카드',
    face: '얼굴',
    finger: '지문',
    code: '코드',
    codeType: '코드 유형',
    passthroughCode: '통과 코드',
    staticCode: '정적 코드',
    dynamicCode: '동적 코드',
    placeholderCode: '코드 인증서를 입력하세요',
    placeholderPwd: '비밀번호 자격을 입력',
    placeholderCard: '카드 자격을 입력',
    validPassword: '6자리 숫자를 입력',
    validCard: '8자리 숫자 또는 문자 입력',
    photoRegistration: '사진 등록',
    featureValueRegistration: '특징값 등록',
    fingerRegistration: '지문 등록',
    fingerFeatureRegistration: '특징값 등록',
    fingerInput: '손가락을 지문 센서에 올려주세요',
    fingerRemainingTime: '남은 시간',
    fingerInputting: '등록 중...',
    startFingerInput: '지문 등록 시작',
    fingerInputTips: '지문 특징값을 입력하세요',
    fingerWaitInput: '등록 대기',
    fingerInputNow: '지문을 등록하는 중...',
    fingerInputSuccess: '등록 성공',
    fingerInputFailed: '지문 등록 시작 실패',
    fingerReTry: '지문 등록 실패, 다시 시도해 주세요',
    fingerFilled: '지문 등록 성공, 특징값이 자동으로 입력되었습니다',
    fingerFailed: '지문 등록 실패',
    fingerTimeout: '시간 초과',
    fingerInputTimeout: '지문 등록 시간 초과, 다시 시도해 주세요',
    fingerError: '등록 실패',
    fingerInputError: '지문 등록 실패, 다시 시도해 주세요',
    fingerInputed: '지문이 이미 등록되었습니다',
    fingerReInput: '지문 재등록',
  },
  permission: {
    deletePermission: '권한 삭제',
    addPermission: '권한 추가',
    permissionId: '권한 ID',
    userId: '사용자 ID',
    timeRange: '시간 범위',
    extra: '추가',
    effectiveType: '유효 유형',
    effectiveTime: '유효 시간',
    effectiveWeek: '유효 주',
    timePeriod: '시간대',
    addTimePeriod: '시간대 추가',
    modify_previous_time: '먼저 이전 시간대를 수정하세요',
    cannot_be_earlier: '종료 시간이 시작 시간보다 빠를 수 없습니다',
    times_cannot_overlap: '시간대가 겹칠 수 없습니다',
    choose_time_range: '시간 범위를 선택하세요',
    unlimitedMode: '무제한 모드',
    usualMode: '일반 모드',
    dailyMode: '일일 모드',
    weeklyRepetitionMode: '주간 반복 모드',
    time_range: '시간 범위',
  },
  common: {
    startDate: '시작 날짜',
    endDate: '종료 날짜',
    to: '부터',
    cancel: '취소',
    confirm: '확인',
    close: '닫기',
    delete: '삭제',
    edit: '수정',
    batchDelete: '일괄 삭제',
    startTime: '시작 시간',
    endTime: '종료 시간',
    monday: '월요일',
    tuseday: '화요일',
    wednesday: '수요일',
    thursday: '목요일',
    friday: '금요일',
    saterday: '토요일',
    sunday: '일요일',
    placeholder: '입력하세요',
    placeholderSelect: '선택하세요',
    closeTips: '닫기를 확인하시겠습니까?',
    deleteTips: '삭제를 확인하시겠습니까?',
    deleteSuccess: '삭제 성공',
    addSuccess: '추가 성공',
    editSuccess: '수정 성공',
    saveSuccess: '저장 성공',
    tips: '알림',
    operation: '작업',
    query: '조회',
    reset: '초기화',
    noData: '데이터 없음',
    export: '내보내기',
    success: '성공',
    failure: '실패',
    incorrectFormat: '형식이 올바르지 않습니다',
    integerFormat: '0 이상의 정수여야 합니다',
    positiveIntegerFormat: '0보다 큰 정수여야 합니다',
    noDataSaved: '저장할 데이터가 없습니다',
    chinese: '중국어',
    english: '영어',
    spanish: '스페인어',
    french: '프랑스어',
    german: '독일어',
    russian: '러시아어',
    arabic: '아랍어',
    portuguese: '포르투갈어',
    korean: '한국어',
    detail: '세부 정보',
    clearTips: '지우시겠습니까?',
    clearSuccess: '성공적으로 지워짐',
  },
  log: {
    accessMethod: '출입 방식',
    passingTime: '출입 시간',
    accessPass: '출입 증명',
    accessResult: '결과',
    accessPhoto: '사진',
    viewPhotos: '사진 보기'
  },
  error: {
    networkError: '네트워크 오류, 연결을 확인하세요',
    timeout: '요청 시간 초과, 다시 시도하세요',
    serverError: '서버 내부 오류, 나중에 다시 시도',
    notFound: '요청한 자원이 없습니다',
    unauthorized: '인증되지 않았습니다. 다시 로그인하세요',
    noResponse: '서버 응답이 없습니다',
    unknownError: '요청 실패, 오류 코드:',
    requestFailed: '요청에 실패했습니다'
  },
  security: {
    keyId: '키 ID',
    keyType: '키 유형',
    keyEncoding: '키 인코딩',
    keyValue: '키 값',
    startTime: '시작 시간',
    expirationTime: '만료 시간',
    newKey: '키 추가',
    clearKey: '키 지우기',
    validTime: '유효 시간',
  }
}
